<template>
    <a-modal :visible="visible"
             :footer="false"
             :hide-title="true"
             width="854px">
        <div class="up-content">
            <div class="titleBox">
                <span class="titleText">{{ $t('deposit.deposit') }}</span>
                <icon-close @click="onCancel" size="22"/>
            </div>
            <div class="container">
                <div class="_left">
                    <div class="label">
                        <p>{{ $t('deposit.deposit_currency') }}</p>
                        <a-trigger position="bottom" v-model:popup-visible="coinShow" :popup-translate="[0, 10]">
                            <div class="select-button">
                                <span class="defalut" v-if="!current">{{current ? current['symbol'] : $t('deposit.select_currency') }}</span>
                                <div class="coin" v-else>
                                    <img :src="current['icon']" alt="">
                                    <span>{{current['symbol']}}</span>
                                </div>
                                <icon-caret-down/>
                            </div>
                            <template #content>
                                <div class="coin-list">
                                    <div class="top">
                                        <a-input class="search" @input="coinSearch" :placeholder="$t('deposit.search_currency')">
                                            <template #prefix>
                                                <icon-search/>
                                            </template>
                                        </a-input>
                                    </div>
                                    <a-scrollbar class="bottom">
                                        <div class="cell" v-for="(item,index) in coin" :key="'rc'+item.id" @click="selectCoin(item)">
                                            <img :src="item['icon']" alt="">
                                            <span>{{ item['symbol'] }}</span>
                                        </div>
                                    </a-scrollbar>
                                </div>
                            </template>
                        </a-trigger>
                        <div class="hot-coin">
                            <div class="item" v-for="(item,index) in coin.slice(0,4)" :key="'q'+item.id" @click="selectCoin(item)">
                                <img :src="item.icon" alt="">
                                <span>{{item.symbol}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="label">
                        <p>{{ $t('deposit.deposit_network') }}</p>
                        <a-trigger position="bottom" v-model:popup-visible="netShow" :popup-translate="[0, 10]">
                            <div class="select-button">
                                <span class="defalut">{{ netlist.length === 0 ? $t('deposit.select_network') : netlist[net]['symbol'] }}</span>
                                <span style="font-size: 12px; color: #999; margin-left: 8px;">({{ net }}/{{ netlist.length }})</span>
                                <icon-caret-down/>
                            </div>
                            <template #content>
                                <div class="network-list">
                                    <a-scrollbar class="scroll">
                                        <div class="cell" v-for="(item,index) in netlist" :key="'net'+item.id" @click="selectNetwork(index)">
                                            <span>{{item['symbol']}} ({{index}})</span>
                                        </div>
                                    </a-scrollbar>
                                </div>
                            </template>
                        </a-trigger>
                    </div>
                    
                    <!-- 充值地址和二维码 -->
                    <div class="label" v-show="token && token !== ''" style="display: flex; flex-direction: column; align-items: center; width: 100%;">
                        <p style="text-align: center !important; width: 100% !important; margin-bottom: 16px !important;">{{ $t('deposit.deposit_address') }}</p>
                        <div class="address-container" style="display: flex; justify-content: center; width: 100%; margin-bottom: 16px;">
                            <div class="address" style="display: flex; align-items: center; justify-content: center; max-width: 300px; width: 100%; background-color: var(--background-tertiary); border: 1px solid var(--border-strength-100); border-radius: 8px; padding: 18px 4px;">
                                <span class="address-text" style="flex: 1; text-align: center; color: var(--content-primary); font-size: 16px;">{{token}}</span>
                                <div class="copy-icon" @click="copyAddress" style="margin-left: 8px; cursor: pointer; padding: 4px; border-radius: 4px; display: flex; align-items: center; justify-content: center;">
                                    <icon-copy style="color: var(--content-secondary); font-size: 16px;" />
                                </div>
                            </div>
                        </div>
                        <div class="code-image" style="display: flex; justify-content: center; margin-bottom: 16px;">
                            <canvas id="qrcodeToken" width="128" height="128" style="width: 128px;height:128px"></canvas>
                        </div>
                        <p class="add_tip" style="text-align: center !important; width: 100% !important;">{{ $t('deposit.copy_address_or_scan') }}</p>
                    </div>
                </div>
                
                <!-- 右侧内容区域 -->
                <div class="_right">
                    <!-- 充值申请表单 -->
                    <div class="recharge-form" v-show="token && token !== ''" style="display: flex; flex-direction: column; align-items: center; width: 100%;">
                        <div class="form-section" style="display: flex; flex-direction: column; align-items: center; width: 100%;">
                            <h3 style="text-align: center !important; width: 100% !important; margin-bottom: 20px !important;">{{ $t('deposit.deposit_application') }}</h3>
                                                                                        <div class="form-item" style="display: flex; flex-direction: column; align-items: center; width: 100%;">
                                <label style="text-align: center !important; width: 100% !important; margin-bottom: 8px !important; display: block !important;">{{ $t('deposit.deposit_amount') }}</label>
                                <div class="amount-input" style="display: flex; justify-content: center; align-items: center; width: 100%; max-width: 300px;">
                                    <a-input-number 
                                        v-model="rechargeAmount" 
                                        :precision="8" 
                                        :formatter="formatInputValue" 
                                        :parser="parseInputValue"
                                        :placeholder="$t('deposit.enter_amount')"
                                        style="width: 100%"
                                    />
                                    <span class="unit">{{ current ? current.symbol : '' }}</span>
                                </div>
                            </div>
                            <div class="form-item" style="display: flex; flex-direction: column; align-items: center; width: 100%;">
                                <label style="text-align: center !important; width: 100% !important; margin-bottom: 8px !important; display: block !important;">{{ $t('deposit.deposit_proof') }}</label>
                                <div style="display: flex; justify-content: center; align-items: center; width: 100%;">
                                    <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; width: 120px;">
                                        <a-upload
                                            :file-list="fileList"
                                            :show-file-list="true"
                                            :limit="1"
                                            accept="image/*"
                                            list-type="picture-card"
                                            class="voucher-upload"
                                            style="display: flex; justify-content: center; align-items: center; width: 100%;"
                                            :before-upload="beforeUpload"
                                            @change="handleFileChange"
                                            @remove="handleFileRemove"
                                        >
                                                                                    <template #upload-button>
                                            <div style="width: 120px; height: 120px; border: 2px dashed #666; border-radius: 12px; background: transparent; display: flex; flex-direction: column; align-items: center; justify-content: center; margin: 0 auto; transition: border-color 0.2s; cursor: pointer; color: #fff;">
                                                <span style="font-size: 40px; color: #fff; line-height: 1; font-weight: bold;">+</span>
                                                <span style="font-size: 14px; color: #fff; margin-top: 4px;">{{ $t('deposit.upload_certificate') }}</span>
                                            </div>
                                        </template>
                                        </a-upload>
                                        <p class="upload-tip" style="text-align: center; margin-top: 12px;">{{ $t('deposit.upload_tip') }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="form-actions" style="display: flex; justify-content: center; gap: 12px; margin-top: 20px;">
                                <a-button type="primary" @click="submitRecharge" :loading="submitting" :disabled="!canSubmit">
                                    {{ submitting ? $t('deposit.submitting') : $t('deposit.submit_deposit_application') }}
                                </a-button>
                                <a-button @click="resetForm">{{ $t('deposit.reset') }}</a-button>
                            </div>
                        </div>
                    </div>
                    
                    <!-- 右侧信息卡片 -->
                    <div class="card">
                        <div class="_cell">
                            <span>{{ $t('deposit.min_deposit_amount') }}</span>
                            <span>
                                {{ current ? current['recharge_min'] : '--' }} {{ current ? current['symbol'] : '' }}
                            </span>
                        </div>
                        <div class="_cell">
                            <span>{{ $t('deposit.deposit_confirmations') }}</span>
                            <span>20 {{ $t('deposit.network_confirmations') }}</span>
                        </div>
                        <div class="_cell">
                            <span>{{ $t('deposit.withdraw_unlock_confirmations') }}</span>
                            <span>20 {{ $t('deposit.network_confirmations') }}</span>
                        </div>
                    </div>
                    <div class="tips">
                        <p>{{ $t('deposit.deposit_reminder_title') }}</p>
                        <span>{{ $t('deposit.non_matching_asset_notice', { symbol: current ? current['symbol'] : '--', network: netlist.length ? netlist[net]['symbol'] : '--' }) }}</span>
                        <span>{{ $t('deposit.address_confirmation_notice') }}</span>
                        <span>{{ $t('deposit.device_security_notice') }}</span>
                    </div>
                </div>
            </div>
        </div>
    </a-modal>
</template>

<script>
import commonApi from '@/common/api/common';
import UQRCode from 'uqrcodejs';
import { IconPlus, IconCopy } from '@arco-design/web-vue/es/icon';

let currency;
export default {
    name: 'upTrigget',
    components: {
        IconPlus,
        IconCopy
    },
    props: {
        visible: {
            default: false,
            type: Boolean
        }
    },
    data() {
        return {
            rechargeNetwork: '',
            coin: [],
            netlist: [],
            net: 0,
            current: false,
            coinShow:false,
            netShow:false,
            token:"",
            remark: {},
            // 充值表单数据
            rechargeAmount: null,
            fileList: [],
            submitting: false,
            // 多网络地址缓存
            multiNetworkAddresses: {}, // {currency_id: {network_id: address}}
            isLoadingAddress: false // 地址加载状态
        }
    },
    computed: {
        canSubmit() {
            return this.rechargeAmount && 
                   this.rechargeAmount > 0 && 
                   this.current && 
                   this.rechargeAmount >= parseFloat(this.current.recharge_min || 0);
        }
    },
    watch: {
        visible(v) {
            if (v) {
                this.getRechargeCurrency();
            }
        },
        // 移除net的watch，因为现在使用selectNetwork方法直接处理
        // net(v){
        //     if (v !== false) {
        //         this.getRechargeToken();
        //     }
        // }
    },
    methods: {
        selectCoin(coin){
            this.current = coin;
            this.coinShow = false;
            this.getNetList(coin['id']);
        },
        coinSearch(e) {
            this.coin = currency.filter((item)=>{
               return item.symbol.toLowerCase().includes(e.toLowerCase());
            });
        },
        getRechargeCurrency() {
            commonApi.getRechargeCurrency().then(res => {
                console.log('🏦 获取充值币种列表原始数据:', res.data.list);
                
                // 使用工具函数过滤可充值的币种
                this.coin = this.$util.filterRechargeCurrencies(res.data.list);
                currency = this.coin;
                
                console.log('✅ 过滤后的可充值币种:', this.coin.map(c => ({symbol: c.symbol, is_recharge: c.is_recharge})));
                if (this.coin.length > 0) {
                    // 优先选择USDT，如果没有USDT则选择第一个币种
                    const usdtCoin = this.coin.find(coin => coin.symbol.toLowerCase() === 'usdt');
                    if (usdtCoin) {
                        this.current = usdtCoin;
                        this.getNetList(usdtCoin.id);
                    } else {
                        // 如果没有USDT，选择第一个币种
                        this.current = this.coin[0];
                        this.getNetList(this.coin[0].id);
                    }
                }
            });
        },
        getNetList(currency_id) {
            commonApi.getNetList(currency_id).then(res => {
                this.netlist = res.data.list;
                this.net = 0;
                // 获取多网络地址
                this.getMultiNetworkAddresses(currency_id);
            })
        },
        /**
         * 获取币种的多网络地址
         */
        getMultiNetworkAddresses(currency_id) {
            console.log('🌐 获取多网络地址，币种ID:', currency_id);
            this.isLoadingAddress = true;
            
            commonApi.getMultiNetworkAddresses(currency_id).then(res => {
                console.log('✅ 获取多网络地址成功');
                
                // 检查API响应的嵌套结构
                let addresses = null;
                if (res && res.data) {
                    if (res.data.addresses) {
                        addresses = res.data.addresses;
                    } else if (res.data.data && res.data.data.addresses) {
                        addresses = res.data.data.addresses;
                    } else if (res.data) {
                        addresses = res.data;
                    }
                }
                
                if (addresses && Array.isArray(addresses)) {
                    console.log('📋 多网络地址列表:', addresses);
                    
                    // 转换为以网络ID为键的对象
                    const addressMap = {};
                    addresses.forEach(item => {
                        addressMap[item.network_id] = {
                            address: item.address,
                            network_symbol: item.network_symbol,
                            network_name: item.network_name,
                            recharge_type: item.recharge_type
                        };
                    });
                    
                    // 缓存多网络地址
                    this.multiNetworkAddresses[currency_id] = addressMap;
                    console.log('💾 多网络地址已缓存:', addressMap);
                    
                    // 获取当前选中网络的地址
                    this.getRechargeToken();
                } else {
                    console.warn('❌ 多网络地址数据格式错误，使用传统方式获取');
                    this.getRechargeToken();
                }
            }).catch(error => {
                console.error('❌ 获取多网络地址失败:', error);
                // 回退到传统方式
                this.getRechargeToken();
            }).finally(() => {
                this.isLoadingAddress = false;
            });
        },
        /**
         * 选择网络
         */
        selectNetwork(networkIndex) {
            console.log('🌐 选择网络，索引:', networkIndex);
            console.log('🌐 当前网络索引:', this.net);
            console.log('🌐 网络列表:', this.netlist);
            
            if (networkIndex === this.net) {
                console.log('⚠️ 选择的是当前网络，无需切换');
                this.netShow = false;
                return;
            }
            
            // 检查网络索引是否有效
            if (networkIndex < 0 || networkIndex >= this.netlist.length) {
                console.error('❌ 无效的网络索引:', networkIndex);
                this.netShow = false;
                return;
            }
            
            // 更新网络选择
            this.net = networkIndex;
            this.netShow = false;
            
            // 调试信息：显示网络匹配情况
            const selectedNetwork = this.netlist[this.net];
            console.log('🔍 选中的网络信息:', selectedNetwork);
            console.log('🔍 当前币种ID:', this.current.id);
            console.log('🔍 缓存中的网络ID:', this.multiNetworkAddresses[this.current.id] ? Object.keys(this.multiNetworkAddresses[this.current.id]) : '无');
            
            // 立即更新充值地址，不使用nextTick
            console.log('🔄 网络切换，立即更新充值地址');
            console.log('🔄 当前网络索引:', this.net);
            console.log('🔄 当前网络信息:', this.netlist[this.net]);
            this.getRechargeToken();
        },
        getRechargeToken() {
            if (!this.current) {
                console.log('❌ 当前币种为空');
                return false;
            }
            
            console.log('🔍 获取充值地址，当前币种:', this.current.symbol, '网络索引:', this.net);
            console.log('🔍 网络列表长度:', this.netlist.length);
            console.log('🔍 当前网络信息:', this.netlist[this.net]);
            
            if (parseInt(this.current.d_c) === 1) {
                // 内置地址模式 - 但优先使用多网络地址缓存
                if (this.multiNetworkAddresses[this.current.id]) {
                    const selectedNetwork = this.netlist[this.net];
                    let cachedAddress = this.multiNetworkAddresses[this.current.id][selectedNetwork.id];
                    
                    if (!cachedAddress) {
                        // 符号匹配
                        const addressMap = this.multiNetworkAddresses[this.current.id];
                        for (const [networkId, addressInfo] of Object.entries(addressMap)) {
                            if (addressInfo.network_symbol === selectedNetwork.symbol) {
                                cachedAddress = addressInfo;
                                break;
                            }
                        }
                    }
                    
                    if (cachedAddress) {
                        console.log('💾 使用多网络地址:', cachedAddress.network_symbol);
                        this.token = cachedAddress.address;
                        this.$nextTick(() => {
                            this.generateQRCode();
                        });
                        return;
                    }
                }
                
                // 回退到内置地址
                console.log('📱 使用内置地址');
                // 安全解析 remark 字段
                try {
                    if (this.current.remark && this.current.remark.trim()) {
                        this.remark = JSON.parse(this.current.remark);
                    } else {
                        this.remark = {};
                    }
                } catch (error) {
                    console.warn('解析 remark 失败，使用空对象:', error);
                    this.remark = {};
                }
                this.token = this.current.d_token;
                this.$nextTick(() => {
                    this.generateQRCode();
                });
            } else {
                // 网络地址模式
                if (this.netlist.length === 0) {
                    console.log('❌ 网络列表为空');
                    return;
                }
                
                const selectedNetwork = this.netlist[this.net];
                console.log('🌐 选中网络:', selectedNetwork.symbol, '网络ID:', selectedNetwork.id);
                
                // 优先使用缓存的多网络地址
                if (this.multiNetworkAddresses[this.current.id]) {
                    let cachedAddress = this.multiNetworkAddresses[this.current.id][selectedNetwork.id];
                    
                    if (!cachedAddress) {
                        // 符号匹配
                        const addressMap = this.multiNetworkAddresses[this.current.id];
                        for (const [networkId, addressInfo] of Object.entries(addressMap)) {
                            if (addressInfo.network_symbol === selectedNetwork.symbol) {
                                cachedAddress = addressInfo;
                                break;
                            }
                        }
                    }
                    
                    if (cachedAddress) {
                        console.log('💾 使用多网络地址:', cachedAddress.network_symbol);
                        this.token = cachedAddress.address;
                        this.$nextTick(() => {
                            this.generateQRCode();
                        });
                        return;
                    }
                }
                
                // 如果缓存匹配失败，使用传统API
                console.log('🔄 使用传统API获取地址');
                commonApi.getRechargeToken(this.netlist[this.net]['id']).then(res => {
                    this.token = res.data.address;
                    console.log('获取到地址:', this.token);
                    this.$nextTick(() => {
                        this.generateQRCode();
                    });
                }).catch(error => {
                    console.error('获取充值地址失败:', error);
                });
            }
        },
        
        generateQRCode() {
            if (this.token) {
                const canvas = document.getElementById("qrcodeToken");
                if (canvas) {
                    try {
                    let qr = new UQRCode();
                        qr.data = this.token;
                    qr.size = 128;
                    qr.make();
                        let canvasContext = canvas.getContext("2d");
                    qr.canvasContext = canvasContext;
                    qr.drawCanvas();
                    } catch (err) {
                        console.error('二维码生成失败:', err);
                    }
                }
            }
        },
        onCancel() {
            // 重置状态
            this.current = false;
            this.token = "";
            this.rechargeAmount = null;
            this.fileList = [];
            this.submitting = false;
            this.$emit('close')
        },
        
        // 充值表单相关方法
        formatInputValue(value) {
            if (!value && value !== 0) return '';
            const num = parseFloat(value);
            if (isNaN(num)) return '';
            // 如果是整数，直接返回整数
            if (Number.isInteger(num)) {
                return num.toString();
            }
            // 如果是小数，去掉末尾的0
            return num.toString().replace(/\.?0+$/, '');
        },
        
        parseInputValue(value) {
            if (!value) return null;
            const num = parseFloat(value);
            return isNaN(num) ? null : num;
        },
        
        beforeUpload(file) {
            // 验证文件大小（最大5MB）
            if (file.size > 5 * 1024 * 1024) {
                this.$message.error(this.$t('personal.file_size_exceeded'));
                return false;
            }
            
            // 验证文件类型
            const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
            if (!allowedTypes.includes(file.type)) {
                this.$message.error(this.$t('deposit.supported_image_formats'));
                return false;
            }
            
            // 限制只能上传1个文件
            if (this.fileList.length >= 1) {
                this.$message.warning(this.$t('deposit.single_file_limit'));
                return false;
            }
            
            // 验证图片尺寸（可选）
            const img = new Image();
            img.onload = () => {
                if (img.width < 100 || img.height < 100) {
                    this.$message.warning(this.$t('deposit.minimum_image_dimensions'));
                }
                if (img.width > 2000 || img.height > 2000) {
                    this.$message.warning(this.$t('deposit.maximum_image_dimensions'));
                }
            };
            img.onerror = () => {
                this.$message.error(this.$t('deposit.invalid_image_format'));
                return false;
            };
            img.src = URL.createObjectURL(file);
            
            // 压缩图片（如果文件大于1MB）
            if (file.size > 1024 * 1024) {
                this.compressImage(file).then(compressedFile => {
                    const fileInfo = {
                        uid: file.uid || Date.now(),
                        name: file.name,
                        status: 'done',
                        url: URL.createObjectURL(compressedFile),
                        file: compressedFile,
                        size: this.formatFileSize(compressedFile.size)
                    };
                    this.fileList = [fileInfo];
                    this.$message.success(this.$t('deposit.file_upload_success_with_size', { size: this.formatFileSize(compressedFile.size) }));
                }).catch(error => {
                    this.$message.error(this.$t('deposit.image_compression_failed'));
                });
            } else {
                // 创建文件URL用于预览
                const fileInfo = {
                    uid: file.uid || Date.now(),
                    name: file.name,
                    status: 'done',
                    url: URL.createObjectURL(file),
                    file: file, // 保存原始文件对象
                    size: this.formatFileSize(file.size) // 添加文件大小显示
                };
                
                // 添加到文件列表
                this.fileList = [fileInfo]; // 替换而不是添加，确保只有一个文件
                this.$message.success(this.$t('deposit.file_upload_success_with_size', { size: this.formatFileSize(file.size) }));
            }
            
            return false; // 阻止默认上传行为，因为我们手动处理
        },
        
        handleFileChange(fileList) {
            // 确保只保留一个文件
            if (fileList.length > 1) {
                this.fileList = [fileList[fileList.length - 1]]; // 保留最后一个上传的文件
            } else {
                this.fileList = fileList;
            }
        },
        
        // 删除文件
        handleFileRemove(file) {
            this.fileList = this.fileList.filter(item => item.uid !== file.uid);
            this.$message.info(this.$t('deposit.file_deleted'));
        },
        
        // 格式化文件大小
        formatFileSize(bytes) {
            if (bytes === 0) return '0 B';
            const k = 1024;
            const sizes = ['B', 'KB', 'MB', 'GB'];
            const i = Math.floor(Math.log(bytes) / Math.log(k));
            return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
        },
        
        // 压缩图片
        compressImage(file) {
            return new Promise((resolve, reject) => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                const img = new Image();
                
                img.onload = () => {
                    // 计算压缩后的尺寸
                    let { width, height } = img;
                    const maxSize = 1200;
                    
                    if (width > height) {
                        if (width > maxSize) {
                            height = (height * maxSize) / width;
                            width = maxSize;
                        }
                    } else {
                        if (height > maxSize) {
                            width = (width * maxSize) / height;
                            height = maxSize;
                        }
                    }
                    
                    canvas.width = width;
                    canvas.height = height;
                    
                    // 绘制压缩后的图片
                    ctx.drawImage(img, 0, 0, width, height);
                    
                    // 转换为Blob
                    canvas.toBlob((blob) => {
                        if (blob) {
                            const compressedFile = new File([blob], file.name, {
                                type: file.type,
                                lastModified: Date.now()
                            });
                            resolve(compressedFile);
                        } else {
                            reject(new Error('图片压缩失败'));
                        }
                    }, file.type, 0.8); // 质量设置为0.8
                };
                
                img.onerror = () => {
                    reject(new Error('图片加载失败'));
                };
                
                img.src = URL.createObjectURL(file);
            });
        },
        
        submitRecharge() {
            if (!this.canSubmit) {
                this.$message.warning(this.$t('deposit.fill_complete_info'));
                return;
            }
            
            this.submitting = true;
            
            // 构建提交数据
            const submitData = {
                chain_network: this.current.id, // 币种ID
                amount: this.rechargeAmount, // 直接使用用户输入的值
                token: this.token, // 充值地址
                voucherImg: this.fileList.length > 0 ? this.fileList[0].url : '' // 取第一个文件作为凭证
            };
            
            // 如果有文件，转换为Base64
            if (this.fileList.length > 0 && this.fileList[0].file) {
                const file = this.fileList[0].file;
                const reader = new FileReader();
                
                reader.onload = (e) => {
                    const base64 = e.target.result;
                    submitData.voucherImg = base64;
                    this.submitRechargeRequest(submitData);
                };
                
                reader.onerror = () => {
                    this.submitting = false;
                    this.$message.error(this.$t('deposit.file_read_failed'));
                };
                
                reader.readAsDataURL(file);
            } else {
                this.submitRechargeRequest(submitData);
            }
            
            console.log('提交充值申请:', submitData);
        },
        
        submitRechargeRequest(submitData) {
            // 调用API
            console.log('提交充值申请数据:', submitData);
            commonApi.submitRecharge(submitData).then(res => {
                this.submitting = false;
                console.log('充值申请响应:', res);
                if (res && res.code === 200) {
                    this.$message.success(this.$t('deposit.submit_success'));
                    this.resetForm();
                    this.onCancel(); // 关闭弹窗
                } else {
                this.$message.error(res?.message || this.$t('deposit.submit_failed'));
                }
            }).catch(error => {
                this.submitting = false;
                console.error('提交充值申请失败:', error);
                this.$message.error(this.$t('deposit.submit_failed'));
            });
        },
        
        resetForm() {
            this.rechargeAmount = null;
            this.fileList = [];
            this.submitting = false;
            this.$message.info(this.$t('deposit.reset'));
        },
        
        // 复制地址功能
        copyAddress() {
            if (this.token) {
                console.log('复制充值地址:', this.token);
                this.$util.copyToClipboard(
                    this.token, 
                    (message) => this.$message.success(this.$t('deposit.address_copied')),
                    (message) => this.$message.warning(message)
                );
            } else {
                this.$message.warning(this.$t('common.no_content_to_copy'));
            }
        },
        
        fallbackCopyText(text) {
            // 备用复制方法
            const textArea = document.createElement('textarea');
            textArea.value = text;
            textArea.style.position = 'fixed';
            textArea.style.left = '-999999px';
            textArea.style.top = '-999999px';
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            
            try {
                const successful = document.execCommand('copy');
                if (successful) {
                    this.$message.success(this.$t('common.copy_success'));
                } else {
                    this.$message.error(this.$util.getI18nText('copy_failed_manual', 'Copy failed, please copy manually'));
                }
            } catch (err) {
                this.$message.error(this.$util.getI18nText('copy_failed_manual', 'Copy failed, please copy manually'));
            }
            
            document.body.removeChild(textArea);
        }
    }
}
</script>

<style lang="scss" scoped>
@import "topup";

// 强制居中上传凭证区域
::deep(.upload-container) {
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100% !important;
}

::deep(.voucher-upload) {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  width: 100% !important;
}

// 强制覆盖picture-card模式的上传组件样式
::deep(.arco-upload-picture-card) {
  width: 120px !important;
  height: 120px !important;
  border: 2px dashed #666 !important;
  border-radius: 12px !important;
  background: transparent !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  margin: 0 auto !important;
  transition: border-color 0.2s;
  cursor: pointer;
}

::deep(.arco-upload-picture-card:hover) {
  border-color: #00b7ff !important;
}

::deep(.arco-upload-picture-card-trigger) {
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100% !important;
  height: 100% !important;
  color: #fff !important;
}

::deep(.arco-upload-list-item) {
  width: 120px !important;
  height: 120px !important;
  border-radius: 12px !important;
  overflow: hidden !important;
  border: 2px solid #666 !important;
  transition: all 0.3s ease !important;
}

::deep(.arco-upload-list-item:hover) {
  border-color: #00b7ff !important;
}

::deep(.arco-upload-list-item img) {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important;
}

// 强制移除复制按钮的悬停效果
::deep(.copy-icon) {
  background-color: var(--background-tertiary) !important;
  color: var(--content-secondary) !important;
  transition: none !important;
}

::deep(.copy-icon:hover) {
  background-color: var(--background-tertiary) !important;
  color: var(--content-secondary) !important;
}
</style>
